import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import OccupationDetailsDTO from '../models/occupation/OccupationDetailsDTO';
import OccupationDTO from '../models/occupation/OccupationDTO';
import TableResponseDTO from '../models/datatable/TableResponseDTO';
import TableRequestDTO from '../models/datatable/TableRequestDTO';

export class OccupationApiController {
    // get: OccupationDb/GetOccupationDetails/${occupationId}
    public RouteGetOccupationDetails = (occupationId: number) => `OccupationDb/GetOccupationDetails/${occupationId}`;
    public getOccupationDetails(occupationId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<OccupationDetailsDTO>> {
        let url = this.RouteGetOccupationDetails(occupationId);
        return HttpApi.RestRequest<any, OccupationDetailsDTO>(null, 'get', url, requestOptions);
    }
    // post: OccupationDb/GetOccupationsTableData
    public RouteGetOccupationsTableData = () => `OccupationDb/GetOccupationsTableData`;
    public getOccupationsTableData(tableRequest: TableRequestDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<OccupationDTO>>> {
        let url = this.RouteGetOccupationsTableData();
        return HttpApi.RestRequest<any, TableResponseDTO<OccupationDTO>>(tableRequest, 'post', url, requestOptions);
    }
}
var service = new OccupationApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/OccupationApiController.ts